import { defineStore } from 'pinia';
import { ref, computed  } from 'vue';
import { useRouter } from 'vue-router';
import authService from '@/services/auth.service';
import { encryptStorage } from './encrypt-storage.service';
import { Login } from '@/models/login.model';

export const useAuthStore = defineStore('auth', () => {
    const user = ref<Login | null>(encryptStorage.getItem("user") || null);
    const isAuthenticated = computed(() => {
        console.log(user);
        if(!user.value || !user.value.token){
            return false;
        }
        return user.value.token !== '';
    }); // todo sprawdzać też czas
    const router = useRouter();

    const login = async (email: string, password: string) => {
        try {
            const response = await authService.authoize(email, password);
            console.log(response);
            user.value = response;
            encryptStorage.setItem("user", response);
            await router.push({name: "AuthLayout"});
        } catch (error) {
            console.error('Login failed:', error);
            throw error;
        }
    };

    const logout = async () => {
        user.value = null; 
        encryptStorage.removeItem("user");
        await router.push({ name: "LoginPanel" });
    };

    return { user, isAuthenticated, login, logout };
});